import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import TextFieldGroup from '../common/TextFieldGroup';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getConferenceById, changeConferenceDetails, getConferences } from '../../actions/clientActions';
import { Container, Row, Col, Table, Button, OverlayTrigger, Popover } from 'react-bootstrap';
//import classnames from 'classnames';
//import SelectListGroup from '../common/SelectListGroup';
import isEmpty from '../../validation/is-empty';
import { Card } from '../Card/Card';

import dateFormat from "dateformat";
import Spinner from '../common/Spinner';
import ReactToExcel from 'react-html-table-to-excel';

import "bootstrap/dist/css/bootstrap.min.css";
// To make rows collapsible
import "bootstrap/js/src/collapse.js";

class ChangeConfInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _id: '',
      conferenceFullName: '',
      speakerFullName: '',
      conferenceDesc: '',
      conferenceDate: '',
      conferenceTimeFrom: '',
      conferenceTimeTo: '',
    };

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    this.props.getConferences();
    if (this.props.match.params._id) {
      this.props.getConferenceById(this.props.match.params._id);
    }
  }

  onSubmit(e) {
    e.preventDefault();
    const conference = {
      _id: this.state._id,
      conferenceFullName: this.state.conferenceFullName,
      speakerFullName: this.state.speakerFullName,
      conferenceDesc: this.state.conferenceDesc,
      conferenceDate: this.state.conferenceDate,
      conferenceTimeFrom: this.state.conferenceTimeFrom,
      conferenceTimeTo: this.state.conferenceTimeTo
    };
    this.props.changeConferenceDetails(conference)
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }

    if (nextProps.conference.conference) {
      const conference = nextProps.conference.conference;

      conference._id = !isEmpty(conference._id) ? conference._id : '';
      conference.conferenceFullName = !isEmpty(conference.conferenceFullName) ? conference.conferenceFullName : '';
      conference.speakerFullName = !isEmpty(conference.speakerFullName) ? conference.speakerFullName : '';
      conference.conferenceDesc = !isEmpty(conference.conferenceDesc) ? conference.conferenceDesc : '';
      conference.conferenceDate = !isEmpty(conference.conferenceDate) ? conference.conferenceDate : '';
      conference.conferenceTimeFrom = !isEmpty(conference.conferenceTimeFrom) ? conference.conferenceTimeFrom : '';
      conference.conferenceTimeTo = !isEmpty(conference.conferenceTimeTo) ? conference.conferenceTimeTo : '';

      // Set component fields state
      this.setState({
        _id: conference._id,
        conferenceFullName: conference.conferenceFullName,
        speakerFullName: conference.speakerFullName,
        conferenceDesc: conference.conferenceDesc,
        conferenceDate: conference.conferenceDate,
        conferenceTimeFrom: conference.conferenceTimeFrom,
        conferenceTimeTo: conference.conferenceTimeTo,
      });
    }
  }

  render() {

    const { loading } = this.props.conferenceList;
    const conferences = this.props.conferenceList.conferenceList;
    const sumConferences = conferences.length;
    console.log(sumConferences)
    let conferenceItems;
    if (conferences === null || loading) {
      conferenceItems = (
        <tr>
          <td>
            <Spinner />
          </td>
        </tr>
      );
    }

    else {
      if (conferences.length > 0) {
        conferenceItems = conferences.map(conference => (
          <> <OverlayTrigger key={conference._id} trigger="hover" placement="bottom" overlay={<Popover>
            <Popover.Header as="h3">Detalji o predavanju</Popover.Header>
            <Popover.Body>
              {conference.conferenceDesc}
            </Popover.Body>
          </Popover>}>
            <tr>
              <td style={{ backgroundColor: '#F8EDE3' }}>{dateFormat(conference.conferenceDate, "dd.mm.yyyy.")} {conference.conferenceTimeFrom} - {conference.conferenceTimeTo} </td>
              <td style={{ backgroundColor: '#FEFCF3' }}>{conference.conferenceFullName}</td>
              <td style={{ backgroundColor: '#F5EBE0' }}>{conference.speakerFullName}</td>
              <td style={{ backgroundColor: '#F5EBE0', display: 'none' }}>{conference.conferenceDesc}</td>
            </tr>
          </OverlayTrigger>

          </>
        ));
      }
      else {
        conferenceItems = (
          <tr>
            <td>Još uvek nema registrovanih učesnika</td>
          </tr>
        );
      }
    }
    return (
      <div className="content">
        <Container fluid>
          <Row>
            <Col md={6}>
              <Card
                title="Izmena/dodavanje konferencija"
                category="Izmena/dodavanje informacija o konferencijama"
                content={
                  <form onSubmit={this.onSubmit} autoComplete="off">
                    <div className="row">
                      <div className="col-md-12">
                        <TextFieldGroup
                          type="text"
                          label="Naziv konferencije"
                          placeholder="Naziv konferencije"
                          name="conferenceFullName"
                          value={this.state.conferenceFullName}
                          onChange={this.onChange}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <TextFieldGroup
                          label="Predavač"
                          placeholder="Predavač"
                          name="speakerFullName"
                          value={this.state.speakerFullName}
                          onChange={this.onChange}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <textarea
                          style={{ height: '150px' }}
                          class="form-control"
                          label="Opis konferencije"
                          placeholder="Opis konferencije"
                          name="conferenceDesc"
                          value={this.state.conferenceDesc}
                          onChange={this.onChange}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <TextFieldGroup
                          type="date"
                          label="Datum konferencije"
                          placeholder="dd-mm-yyyy"
                          name="conferenceDate"
                          value={this.state.conferenceDate}
                          onChange={this.onChange}
                        />
                      </div>
                      <div className="col-md-3">
                        <TextFieldGroup
                          type='time'
                          label="Od"
                          placeholder="početak predavanja"
                          name="conferenceTimeFrom"
                          value={this.state.conferenceTimeFrom}
                          onChange={this.onChange}
                        />
                      </div>
                      <div className="col-md-3">
                        <TextFieldGroup
                          type='time'
                          label="Do"
                          placeholder="kraj predavanja"
                          name="conferenceTimeTo"
                          value={this.state.conferenceTimeTo}
                          onChange={this.onChange}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <input
                          type="submit"
                          value="Sačuvaj"
                          className="btn-fill col-md-12 pull-center btn"
                          style={{ margin: '3px', backgroundColor: '#6096B4', border: 'none' }}
                        />
                      </div>
                      <div className="col-md-6">
                        <Link
                          to="/clients"
                          className="btn-fill col-md-12 pull-center btn btn-default"
                          style={{ margin: '3px' }}
                        >
                          Nazad na admin stranicu
                        </Link>
                      </div>
                    </div>
                    <div className="clearfix"> </div>
                  </form>
                }
              />
            </Col>

            <Col md={6}>
              <Card
                title={'Konferencije [' + [sumConferences] + ']'}
                category="Spisak registrovanih konferencija"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <>
                    <Table striped hover id="table-to-xls" >
                      <thead>
                        <tr>
                          <th>Vreme</th>
                          <th>Tema</th>
                          <th>Predavač</th>
                          <th style={{ display: 'none' }}>Opis</th>
                        </tr>
                      </thead>
                      <tbody>{conferenceItems}</tbody>
                    </Table>
                    <ReactToExcel
                      font="TimesNewRoman"
                      className="btn btn-fill btn-sm"
                      table="table-to-xls"
                      filename={'Spisak registrovanih konferencija '+ new Date().toLocaleDateString("rs-RS")}
                      sheet="sheet 1"
                      buttonText="Preuzmite excel listu konferencija"
                    />
                  </>}
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

ChangeConfInfo.propTypes = {
  getConferenceById: PropTypes.func.isRequired,
  getConferences: PropTypes.func.isRequired,
  changeConferenceDetails: PropTypes.func.isRequired,
  conference: PropTypes.object.isRequired,
  conferenceList: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  conference: state.conference,
  conferenceList: state.conferenceList,
  errors: state.errors,
});

export default connect(
  mapStateToProps,
  { getConferenceById, changeConferenceDetails, getConferences }
)(withRouter(ChangeConfInfo));
